import React from 'react';

const Footer = ({
  translations,
  hasUGAccess = false,
  isUgCgrStreakStats = false,
}) => (
  <div className="psm__form-footer-container">
    <div className="psm__form-footer-title">
      {
        hasUGAccess ? (
          translations?.footerTitleSst) : (translations?.footerTitle
        )
      }
    </div>
    <div className="psm__form-footer-content">
      {isUgCgrStreakStats && `To start sharing - visit the SST Merch store`}
      {
        !isUgCgrStreakStats
        && (
          hasUGAccess
            ? `Earn coins through LinkedIn posts and referrals
        To start sharing - visit the SST Merch store`
            : `Submit 
        your LinkedIn Post's Link above to know more.`
        )
      }
    </div>
  </div>
);

export default Footer;
